export default `
§ uiKit.console.button: コピー
§ uiKit.console.notification: テキストがコピーされました
§ uiKit.dataLoader.page: ページ
§ uiKit.dataLoader.size: によって表示される
§ uiKit.dataLoader.rows: lines.
§ uiKit.dataLoader.from: から
§ uiKit.dataLoader.all: すべて表示
§ uiKit.hoursChart.work: 標準労働時間 (平日,から07:00へ20:00)
§ uiKit.hoursChart.weekend: 休業日または営業日前後の時間
§ uiKit.hoursChart.days: 特定日時における総コミット数を日本語に翻訳してください。
§ uiKit.page.remove: 削除
§ uiKit.nothingFound.common.title: 表示するデータがない、または不十分なデータがあります
§ uiKit.nothingFound.common.description: コミットが次の形式で署名されている場合、システムはより多くのデータを処理します [Git commit message convention|https://www.conventionalcommits.org/en/v1.0.0/]. パターン:
§ uiKit.nothingFound.common.console: Task_numberタイプ(モジュール): 説明
§ uiKit.nothingFound.common.example: 説明:
§ uiKit.nothingFound.staff.title: この従業員のデータはありません
§ uiKit.nothingFound.staff.description1
彼は、毎日作業日のうち правки を行いませんでした。したがって、 “助手” という勤務種別を取得しました。
そのような職種を持つ従業員の統計は無視できます。彼の知識は微妙です。
§ uiKit.nothingFound.staff.description2
システムはそれのためのいくつかの指標を計算しません。
もしそれがエラーであり、その従業員に関する統計を扱う必要がある場合、“設定” セクションに移動してタイプを変更してください。
§ common.title: Git 統計
§ common.filters: フィルター
§ common.notifications.save: 変更は保存されます
§ common.notifications.setting: 設定が保存されます
§ common.fileLoader.notification: Cant open file $1
`;
